import Constants from "../../constants";
import {
    CONFIGURATION_LOADED,
    SET_MENU_CACHE,
    SET_TOTAL_PRICE,
    SET_ACTIVE_MENU_PATH,
    CONFIGURATION_CHANGED,
    SET_SUMMARIES,
    SET_LAYOUT_GROUPS,
    ACTIVATE_FAVORITE,
    SET_ACTIVE_LAYOUT_GROUP,
    SET_FAVORITE_OVERLAY_ACTIVE,
    SET_LAYOUT_OVERLAY_ACTIVE,
} from "../actions/configurationActions";
import { RESET_FOR_MODEL_SELECTOR } from "../actions/sessionActions";
import ConfigurationState from "../stateTypes/configurationState";

const initialState: ConfigurationState = {
    modelId: null,
    category: null,
    configurationString: null,
    selectedMenu: Constants.rootMenuId,
    menus: {},
    summaries: [],
    activeMenuPath: [],
    layoutGroups: [],
    activeLayoutGroup: null,
    activeSurfaceProductIds: new Set<number>(),
    totalPriceText: null,
    totalPrice: null,
    favoriteOverlayActive: false,
    layoutOverlayActive: false,
};

const getActiveSurfaceProductIds = (state: ConfigurationState, action: any) => {
    const ids = action.activeSurfaceProductIds ? new Set<number>(action.activeSurfaceProductIds) : null;
    return ids || state.activeSurfaceProductIds;
};

const configurationReducer = (state: ConfigurationState = initialState, action: any = {}) => {
    switch (action.type) {
        case CONFIGURATION_LOADED:
            return {
                ...state,
                configurationString: action.configurationString,
                modelId: action.modelId,
                category: action.category,
                activeSurfaceProductIds: getActiveSurfaceProductIds(state, action),
            };
        case SET_MENU_CACHE:
            return {
                ...state,
                menus: action.menus,
            };
        case SET_SUMMARIES:
            return {
                ...state,
                summaries: action.summaries,
            };
        case SET_ACTIVE_MENU_PATH:
            return {
                ...state,
                activeMenuPath: action.activeMenuPath,
                selectedMenu:
                    action.activeMenuPath.length > 0
                        ? action.activeMenuPath[action.activeMenuPath.length - 1].id
                        : Constants.rootMenuId,
            };
        case SET_LAYOUT_GROUPS:
            return {
                ...state,
                layoutGroups: action.layoutGroups,
            };
        case SET_ACTIVE_LAYOUT_GROUP:
            return {
                ...state,
                activeLayoutGroup: action.activeLayoutGroup,
            };
        case SET_TOTAL_PRICE:
            return {
                ...state,
                totalPriceText: action.totalPriceText,
                totalPrice: action.totalPrice,
            };
        case CONFIGURATION_CHANGED: {
            const newState = {
                ...state,
                modelId: action.modelId,
                category: action.category,
                configurationString: action.configurationString,
                activeSurfaceProductIds: getActiveSurfaceProductIds(state, action),
            };
            return newState;
        }
        case ACTIVATE_FAVORITE:
            return {
                ...state,
                configurationString: action.configurationString,
            };
        case SET_FAVORITE_OVERLAY_ACTIVE:
            return {
                ...state,
                favoriteOverlayActive: action.favoriteOverlayActive,
            };
        case SET_LAYOUT_OVERLAY_ACTIVE:
            return {
                ...state,
                layoutOverlayActive: action.layoutOverlayActive,
            };
        case RESET_FOR_MODEL_SELECTOR:
            return initialState;
        default:
            return state;
    }
};

export default configurationReducer;
